import {createGlobalStyle} from 'styled-components'
// Load Open Sans typeface
import 'typeface-open-sans'

export const GlobalStyle = createGlobalStyle`

   * {
     margin: 0;
     padding: 0;
   }
   
   *,
   *:before,
   *:after {
     box-sizing: inherit;
   }

   html {
      height: 100%;
      width: 100%;
      box-sizing: border-box;
      overflow-x: hidden;
   }
   body {
     width: 100vw;
     height: 100vh;
     font-family: 'Open Sans', sans-serif;
     touch-action: manipulation; /* Remove click delay */
     box-sizing: border-box;
   }
   
   input:focus,
   select:focus,
   textarea:focus,
   button:focus {
     outline: none;
   }

   *:focus {
     outline: none;
   }
`
